export default "__VITE_ASSET__Q0Bt2S_C__"